(function (angular) {
    angular.module('bizPartEngage').directive('bizCountdownTimer', bizCountdownTimer);
    angular.module('bizPartEngage').service('bizCountdownService', bizCountdownService);

    bizCountdownTimer.$inject = ["bizCore", "bizCountdownService", "bizUser"];
    bizCountdownService.$inject = ["$http"];

    function bizCountdownTimer(bizCore, bizCountdownService, bizUser) {
        var directive = {
            restrict: "E",
            scope: {
            },
            templateUrl: bizCore.getView('core.directives.countdowntimer', "FrontEnd/Core/Directives/Views/CountdownTimer.html"),
            link: linkController,
            bindToController: true,
            controller: bizMyNotesController,
            controllerAs: "vm"
        }

        function linkController(scope, element, attrs) {
            //Remove directive if we don't have access to it.
            if(!bizUser.HasModuleAccess("COUNTDOWN", 10)) {
                scope.$destroy();
                element.remove();
            }
        }

        bizMyNotesController.$inject = ["$rootScope", "$interval"];

        function bizMyNotesController($rootScope, $interval) {
            var vm = this;
            vm.Countdown = {};
            vm.interval;

            vm.StartTimer = StartTimer;
            vm.CancelTimer = CancelTimer;
            vm.ResetTime = ResetTime;

            function StartTimer(ignoreUpdate) {
                if(vm.HasAccessToStartTimer && !ignoreUpdate) {
                    vm.Countdown.StartTime = moment().utc().format();
                    bizCountdownService.StartCountdown(vm.Countdown).then(function(response) {
                        vm.Countdown.Id = response.data.Id;
                    });
                }

                vm.interval = $interval(function() {
                    if(~~vm.Countdown.Seconds <= 0) {
                        vm.Countdown.Seconds = 59;
                        vm.Countdown.Minutes = (~~vm.Countdown.Minutes - 1).toString();
                    }
                    else {
                        vm.Countdown.Seconds = (~~vm.Countdown.Seconds - 1).toString();
                        if(~~vm.Countdown.Seconds < 10) vm.Countdown.Seconds = "0" + (~~vm.Countdown.Seconds).toString();
                    }

                    if(~~vm.Countdown.Minutes < 10) vm.Countdown.Minutes = "0" + (~~vm.Countdown.Minutes).toString();

                    if(~~vm.Countdown.Minutes <= 0 && vm.Countdown.Seconds <= 0) {
                        $interval.cancel(vm.interval);
                        vm.TimerStarted = false;
                    }
                    
                }, 1000, 0, true, vm);
                vm.TimerStarted = true;
            }

            function CancelTimer() {
                if(vm.HasAccessToStartTimer) {
                    bizCountdownService.CancelCountdown(vm.Countdown);
                }

                $interval.cancel(vm.interval);
                vm.TimerStarted = false;
            }

            function ResetTime() {
                vm.Countdown.Minutes = "10";
                vm.Countdown.Seconds = "00";
            }

            function Init() {
                vm.ResetTime();
                vm.HasAccessToStartTimer = bizUser.HasModuleAccess("COUNTDOWN", 20);

                if(bizUser.HasModuleAccess("COUNTDOWN", 10)) {
                    bizCountdownService.GetCountdownForLoggedinUser().then(GetCountdownForLoggedinUserSuccess);
                }

                function GetCountdownForLoggedinUserSuccess(response) {
                    if(response.data) {
                        var countdown = response.data;
                        vm.Countdown.Id = countdown.Id;
                        vm.Countdown.CreatedByUserFullName = countdown.CreatedByUserFullName;
                        var elapsedSeconds = moment(moment().utc()).diff(countdown.StartTime, 'seconds');
                        var elapsedMinutes = Math.floor(elapsedSeconds / 60);
                        elapsedSeconds = Math.floor(elapsedSeconds % 60);
                        
                        vm.Countdown.Minutes = countdown.Minutes - elapsedMinutes;

                        var secondsLeft = countdown.Seconds - elapsedSeconds;

                        if(secondsLeft < 0) {
                            vm.Countdown.Minutes--;
                            vm.Countdown.Seconds = 60 + secondsLeft;
                        }
                        else {
                            vm.Countdown.Seconds = secondsLeft;
                        }

                        vm.StartTimer(true);
                    }
                }
            }

            var hubListender = $rootScope.$on('HUB_COUNTDOWN', function(event, args) {
                var c = JSON.parse(args.Content);
                if(!vm.TimerStarted && !c.Cancelled) {
                    vm.Countdown = c;
                    vm.StartTimer(true);
                }
                else if(vm.TimerStarted === true && c.Cancelled === true) {
                    vm.CancelTimer();
                }
            });

            function Destroy() {
                //Unsubscribe for the hub event...
                hubListender();
            }

            vm.$onInit = Init;
            vm.$onDestroy = Destroy;
        }

        return directive;
    }

    function bizCountdownService($http) {
        var servicePath = siteRootPath + "api/Countdown/";

        this.GetCountdownForLoggedinUser = function() {
            return $http.get(servicePath + "GetCountdownForLoggedinUser");
        };

        this.StartCountdown = function(countdown) {
            return $http.post(servicePath + "StartCountdown", countdown);
        };

        this.CancelCountdown = function(countdown) {
            return $http.post(servicePath + "CancelCountdown", countdown);
        };  
    }

})(window.angular);
